import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';

import {Observable} from 'rxjs';
import {environment} from '@env';
import {
  Success,
  DateRange,
  StaffStats,
  AddStaff,
  UserById,
  StaffMembers,
  UserLogin,
  HostProfile, UserProfileChange
} from '@core/models';

@Injectable({
  providedIn: 'root'
})
export class StaffService {

  constructor(
    private http: HttpClient,
  ) {
  }

  public getStaffMembers(offset: number, limit: number): Observable<{ hosts: StaffMembers[], hostsCount: number }> {
    return this.http.get<{ hosts: StaffMembers[], hostsCount: number }>
    (`${environment.apiUrl}manager/listed-hosts?offset=${offset}&limit=${limit}`);
  }

  public getStaffStats(data: DateRange): Observable<StaffStats> {
    return this.http.post<StaffStats>(`${environment.apiUrl}manager/stats`, data);
  }

  public getMemberById(id: string): Observable<UserById> {
    return this.http.get<UserById>(`${environment.apiUrl}users/${id}`);
  }

  public saveStaffMember(id: string, data: FormData): Observable<AddStaff> {
    if (id) {
      return this.http.patch<AddStaff>(`${environment.apiUrl}users/host-limited/${id}`, data);
    }
    return this.http.post<AddStaff>(`${environment.apiUrl}auth/add-host`, data);
  }

  public archiveMember(id: string): Observable<Success> {
    return this.http.patch<Success>(`${environment.apiUrl}manager/archive/${id}`, []);
  }

  public getArchivedMembers(): Observable<StaffMembers[]> {
    return this.http.get<StaffMembers[]>(`${environment.apiUrl}manager/user-archived`);
  }

  public getHostProfile(): Observable<HostProfile> {
    return this.http.get<HostProfile>(`${environment.apiUrl}users/auth-host`);
  }

  public makeMemberActive(data: { ids: string[] }): Observable<StaffMembers[]> {
    return this.http.patch<StaffMembers[]>(`${environment.apiUrl}manager/active`, data);
  }

  public changeProfile(data: UserProfileChange): Observable<UserLogin> {
    return this.http.patch<UserLogin>(`${environment.apiUrl}users/host`, data);
  }

  public changeProfileImage(data: FormData): Observable<Success> {
    return this.http.patch<Success>(`${environment.apiUrl}users/host-photos`, data);
  }
}
